module.exports = __webpack_public_path__ + "img/rotten_paprika_yellow.d55d0019.png";